import { render } from "./Pusher.vue?vue&type=template&id=4dfc210c"
import script from "./Pusher.vue?vue&type=script&lang=js"
export * from "./Pusher.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\coreme\\suporte\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__